/* global AppVersion */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { isStaticRender, getFontClassName } from 'helpers/ContentHelper';
import { authMVPDLogoutV2 } from 'helpers/AuthHelper';
import { useMvpdAuth } from 'hooks';
import { fetchFooter, fetchFooterPromos } from './FooterActions';
import Style from './Footer.module.scss';
import Promos from './components/Promos';
import Legal from './components/Legal';
import FooterContent from './components/FooterContent';

const NAME = 'Footer';

const Footer = props => {
  const {
    accessToken,
    deviceId,
    appView,
    geoLocationBlocked: isBlocked,
    isAppViewExcluded,
    isPageLoading,
    breakpoint,
    maintenance: isMaintenance,
    isAuthenticated,
    mvpdProviders,
  } = props;

  const dispatch = useDispatch();

  const { fetched, links, networks, connect, legal, promosPanels } = useSelector(
    state => state.footer,
  );

  const footerContent = {
    links,
    networks,
    connect,
  };

  useEffect(() => {
    dispatch(fetchFooter(deviceId));

    if (!isStaticRender()) {
      if (fetchFooterPromos) {
        dispatch(fetchFooterPromos(accessToken, deviceId));
      }
    }
  }, []);

  const { providerSet, setProviderSet } = useMvpdAuth({
    mvpdProviders,
    isAuthenticated,
  });

  const onLogoutClick = async e => {
    e.preventDefault();
    await authMVPDLogoutV2(props, () => {
      setProviderSet(false);
    });
  };

  if (isMaintenance || isBlocked || (appView && isAppViewExcluded(NAME))) return null;
  if (isPageLoading) return null;

  const promos = promosPanels;
  const footerStyle = classNames([Style.Footer, getFontClassName(Style)]);
  const containerClass = classNames(Style.container, !promos && Style.noFirstBorder);

  return (
    <>
      {fetched && (
        <footer data-test="footer" className={footerStyle}>
          <div className={containerClass}>
            {promosPanels && (
              <Promos theme={Style} promosPanels={promosPanels} breakpoint={breakpoint} />
            )}
            <FooterContent
              theme={Style}
              content={footerContent}
              providerSet={providerSet}
              onLogoutClick={onLogoutClick}
            />
            <Legal theme={Style} legal={legal} />
            <div style={{ display: 'none' }}>{AppVersion || ''}</div>
          </div>
        </footer>
      )}
    </>
  );
};

Footer.defaultProps = {
  accessToken: null,
  deviceId: null,
  geoLocationBlocked: false,
  isPageLoading: false,
  mvpdProviders: null,
  isAuthenticated: false,
};

Footer.propTypes = {
  accessToken: PropTypes.string,
  appView: PropTypes.bool.isRequired,
  breakpoint: PropTypes.string.isRequired,
  deviceId: PropTypes.string,
  geoLocationBlocked: PropTypes.bool,
  isAppViewExcluded: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool,
  maintenance: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool,
  mvpdProviders: PropTypes.arrayOf(PropTypes.shape({})),
};

Footer.fetchData = () => null;

export default Footer;
